export const RESEND_LINK_LABEL = "Resend Link";

export const RESEND_LINK_DISABLED_MSG = {
  PROVIDER_VERIFIED: "Provider Already Verified",
  USER_VERIFIED: "User Already Verified",
  // Resend Link is gated on emailVerified only; a pending email change does not disable it.
  // EMAIL_CHANGE_PENDING:
  //   "A verification link has already been sent to the new email",
} as const;

export const USER_TABLE_ROW_HEIGHT = 44;
